import { Control } from "Controls/Control";
import { Util } from "Core";

/**
 * Base class for date controls.
 * @hidden
 */
export abstract class BaseDateControl extends Control {
    /**
     * @hidden
     */
    protected _baseKendoElement: kendo.ui.Widget;

    protected changeFocusCount: number = 0;

    protected setNextFocus() {
        setTimeout(() => {
            let ev = $.Event("keydown");
            ev.keyCode = 39;
            this.jQueryElement.trigger(ev);
        }, 100);
    }

    /**
     * Handle the paste event for this control because kendo does not handle it.
     * @param e
     */
    protected onPaste(e: JQuery.TriggeredEvent) {
        let pasteData: string;

        if (e.originalEvent && (<ClipboardEvent>e.originalEvent).clipboardData) {
            pasteData = (<ClipboardEvent>e.originalEvent).clipboardData.getData("text/plain");
        } else if ((<any>window).clipboardData) {
            pasteData = (<any>window).clipboardData.getData("Text");
        }

        let date = Util.parseDate(pasteData, "en-US");
        if (date == null) {
            date = Util.parseDate(pasteData, "de");
        }
        if (date == null) {
            date = Util.parseDate(pasteData);
        }
        if (date != null) {
            this.setValue(date);
        }
    }

    /**
     * Set the start view and the depth for the calendar.
     * Possible values are:
     * "month" - Shows the days of the month.
     * "year" - Shows the months of the year.
     * "decade" - Shows the years of the decade.
     * "century" - Shows the decades from the century.
     * @param start Start view for the calendar.
     * @param depth The maximum view allowed for this calendar. Depth must be higher than start.
     * @since 4.0.0
     */
    public setStartDepth(start: string, depth: string): void {
        this._baseKendoElement.setOptions({ start: start, depth: depth });
    }

    protected parseValue(value: Date | string) {
        let newValue: Date = null;
        if (!value) {
            newValue = null;
        } else if (value instanceof Date) {
            newValue = value;
        } else {
            // try parsing in current culture and english culture.
            let parsedValue = <Date>Util.parse("date", value.toString());
            if (parsedValue == null) {
                parsedValue = <Date>Util.parse("date", value.toString(), "en-US");
            }
            newValue = parsedValue;
        }
        return newValue;
    }

    /**
     * Gets the datatype for the ViewModel (ie. "string", "number", etc.)
     * @hidden
     */
    public getModelDatatype(): string {
        return "date";
    }
}
